jQuery(document).ready(function($) {
    const menuBar = $('#ahec-menu-bar');
    const skipLink = $('.skip-link');
    if (menuBar.length && skipLink.length) {
        menuBar.insertAfter(skipLink);
    }
});